import AuthService from "./auth/AuthService";

const auth = new AuthService();

/**
 * Vue resource global interceptor, sets authorization
 * header on all outbound requests.
 */
export const requestProcessing = request => {
  if (!auth.isAuthenticated()) {
    auth.login();
  }
  const token = auth.getIdToken();

  // modify headers
  request.headers.set("Authorization", `Bearer ${token}`);
};
